export const FileToBase64 = (file: File): any =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => resolve(event?.target?.result?.toString().split(",")[1]);
    reader.onerror = (error) => reject(error);
  });
